import React, { useContext, useEffect, useState } from 'react'
import { LocaleContext } from '../../contexts/LocaleContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from '../../services/toastService';
import { useValidation } from '../../hooks/useValidation';
import {urlConfig} from "../../config/baseUrl";
import { createCitySchema } from '../../validation/citySchema';
import { cityService } from '../../services/cityService';
import Loading from '../../components/common/Loading';
import BackButton from '../../components/common/BackButton';

const CityForm = () => {

    const {t} = useContext(LocaleContext);
    const { id } = useParams();
    const isEditMode=Boolean(id);
    const [isFilePicked, setIsFilePicked] = useState(false);
    const navigate = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const initialForm = {
      name: "",
      nameEn: "",
    };

    const v = useValidation();
    const schema = createCitySchema(v, t, isEditMode);

    useEffect(()=>{
         if (isEditMode) editAsync();
    },[]);

    //validation
        const {
          register,
          handleSubmit,
          setValue,
          control,
          reset,
          formState: { errors },
          watch,
        } = useForm({
          defaultValues: initialForm,
          resolver: yupResolver(schema),
        });

         const handleClear = () => {
           reset(initialForm); // resets to initial values
         };

        const onSubmit = async (values) => {
          try {
            const formData = new FormData();
            // Append DTO fields
            Object.entries(values).forEach(([key, value]) => {
              if (value !== null && value !== undefined && key !== "file") {
                formData.append(key, value);
              }
            });
        
            // Append file (must match backend parameter name)
            if (values.file) {
              formData.append("file", values.file);
            }
            if (isEditMode) {
             await updateAsync(formData);
            } else {
              await addAsync(formData);
            }
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } 
        };
        const addAsync = async (formData) => {
          try {
            setBtnLoading(true);
            var response = await cityService.create(formData);
            if (!response.isSuccess) {
              response.key?toast.error(t(response.key)): toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            toast.success(t("recordAddedSuccessfully"));
            navigate("/cities");
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } finally {
            setBtnLoading(false);
          }
        };
         const editAsync = async () => {
            const response = await cityService.edit(id);
        
            if (!response.isSuccess) {
              toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            const data = response.value;
            console.log(data);
            setPreviewImage(data.imagePath);
            reset({
              name: data.name,
              nameEn: data.nameEn,
            });
          };
        const updateAsync = async (formData) => {
          try {
            setBtnLoading(true);
            var response = await cityService.update(id, formData);
            if (!response.isSuccess) {
               response.key
                 ? toast.error(t(response.key))
                 : toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
              return;
            }
            toast.success(t("recordUpdatedSuccessfully"));
            navigate("/cities");
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } finally {
            setBtnLoading(false);
          }
        };
        const deleteImage = async () => {
          try {
            setLoading(true);
            var response = await cityService.deleteImageAsync(id);
            if (!response.isSuccess) {
              toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              return;
            } else {
              toast.success(t("recordDeletedSuccessfully"));
              setPreviewImage(null);
            }
          } catch (error) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(error);
          } finally {
            setLoading(false);
          }
        };

if(loading) return <Loading />
  return (
    <>
      <section className="provider-form">
        <div className="default-heading">
          {t("providersDashboardAndManagement")}
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="my-card">
            <div className="my-card-header d-flex justify-content-between align-items-center">
              {isEditMode ? (
                <>
                  <i className="fas fa-edit"></i> {t("editOrSelectedNarrator")}
                </>
              ) : (
                <>
                  <i className="fas fa-plus plus-icon"></i>{" "}
                  {t("addNewCity")}
                </>
              )}
              <BackButton />
            </div>
            <div className="my-card">
              <div className="my-card-header text-primary">
                {t("basicInformation")}
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("name")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("name")}
                      className="form-control"
                      placeholder={t("name")}
                    />
                    {errors.name && (
                      <p className="text-danger">{errors.name.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {t("nameEn")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("nameEn")}
                      {...register("nameEn")}
                    />
                    {errors.nameEn && (
                      <p className="text-danger">
                        {errors.nameEn.message}
                      </p>
                    )}
                  </div>
                </div>
                 {!previewImage ? (
                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-label">
                        {t("profilePicture")}
                      </label>

                      <input
                        type="file"
                        id="provider-profile-picture"
                        className="d-none"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files?.[0];

                          if (file) {
                            setValue("file", file);
                            setIsFilePicked(true);
                          }
                        }}
                      />

                      <label
                        htmlFor="provider-profile-picture"
                        className="my-file-upload"
                      >
                        <span>
                          {t("dragAndDropTheImageHereOr")}{" "}
                          <span className="text-primary">
                            {t("browseImages")} {isFilePicked && "(1)"}
                          </span>
                        </span>

                        <i className="fas fa-camera" />
                      </label>
                    </div>
                  </div>
                ) : (
                  <div className="col-12">
                    <div className="form-group">
                      <div className="preview-images">
                        <div className="preview-image">
                          <img
                            src={`${urlConfig.imageBaseUrl}/${previewImage}`}
                          />
                          <i
                            className="fas fa-times"
                            onClick={() => deleteImage()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="mt-3 gap-2 d-flex justify-content-end">
              {!btnLoading && (
                <button type="submit" className="btn-default">
                  {t("save")}
                </button>
              )}
              {btnLoading && (
                <button type="button" className="btn-default">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </button>
              )}
              {isEditMode && (
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={handleClear}
                >
                  {t("reset")}
                </button>
              )}
              {!isEditMode && (
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={handleClear}
                >
                  {t("reset")}
                </button>
              )}
            </div>
          </div>
        </form>
      </section>
    </>
  );
}

export default CityForm